import type { SVGProps } from 'react';

// Nav icon set geometry: 28 grid, stroke 1.75, centerline bounds 2.333..25.667
// so the painted ink spans exactly the same band as lucide Calendar/Settings
// at equal render size. Verified by the measured-bounds table in the
// Icons/HeaderNavIcons story — keep it green when editing.
const SvgTicket = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.167 2.333H19.833C24.5 2.333 25.667 3.5 25.667 8.167V11.083A2.917 2.917 0 0 0 25.667 16.917V19.833C25.667 24.5 24.5 25.667 19.833 25.667H8.167C3.5 25.667 2.333 24.5 2.333 19.833V16.917A2.917 2.917 0 0 0 2.333 11.083V8.167C2.333 3.5 3.5 2.333 8.167 2.333Z"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.667 2.333L11.667 25.667"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="4.667 4.667"
    />
  </svg>
);
export default SvgTicket;
